import { createFileRoute, useParams } from '@tanstack/react-router'

import { TechnicianMarkAsArrived } from '../../../../../../components/request-drawer/multi-request-drawer/action/technician-in-progress/TechnicianMarkAsArrived'

export const Route = createFileRoute(
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { providerBranchId, requestId } = useParams({
    from: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival',
  })
  return <TechnicianMarkAsArrived providerBranchId={providerBranchId} requestId={requestId} />
}
